export const FETCH_UPDATED_USER_LIST_REQ = 'FETCH_UPDATED_USER_LIST_REQ'
export const FETCH_UPDATED_USER_LIST_SUCC = 'FETCH_UPDATED_USER_LIST_SUCC'
export const FETCH_UPDATED_USER_LIST_ERR = 'FETCH_UPDATED_USER_LIST_ERR'
